import { state } from './state';
import { getters } from './getters';
import { mutation } from './mutations';
import { actions } from './action';
export const passport = {
    namespaced: true,
    state,
    getters,
    mutations: mutation,
    actions
};
